import React from 'react';
import { ClipboardCheck } from 'lucide-react';

const InstructionsStep = () => {
    return (
        <div className="step-container">
            <style>{`
                .instructions-card {
                    background: #f8fafc;
                    border: 1px solid #e2e8f0;
                    border-radius: 8px;
                    padding: 1.25rem 1.5rem;
                }
                .instructions-title {
                    font-size: 1rem;
                    font-weight: 600;
                    color: #1e293b;
                    margin-bottom: 0.75rem;
                    display: flex;
                    align-items: center;
                    gap: 0.5rem;
                }
                .instructions-intro {
                    font-size: 0.875rem;
                    color: #64748b;
                    margin-bottom: 0.75rem;
                }
                .instructions-list {
                    list-style: none;
                    padding: 0;
                    margin: 0;
                }
                .instructions-list li {
                    padding: 0.375rem 0;
                    color: #475569;
                    font-size: 0.875rem;
                    display: flex;
                    align-items: flex-start;
                    gap: 0.5rem;
                    line-height: 1.4;
                }
                .instructions-list li::before {
                    content: '';
                    display: inline-block;
                    width: 5px;
                    height: 5px;
                    min-width: 5px;
                    background: #94a3b8;
                    border-radius: 50%;
                    margin-top: 0.45rem;
                }
            `}</style>

            <div className="instructions-card">
                <div className="instructions-title">
                    <ClipboardCheck size={18} color="#3b82f6" />
                    Instruktioner
                </div>

                <p className="instructions-intro">
                    Din momsrapport fylls i baserat på bokföringen för perioden. Kontrollera att följande stämmer innan du fortsätter:
                </p>

                <ul className="instructions-list">
                    <li>Alla utgifter och inkomster för perioden är bokförda</li>
                    <li>Alla kund- och leverantörsfakturor är registrerade</li>
                    <li>Betalningskontona i bokföringen stämmer överens med bankens kontoutdrag</li>
                    <li>Vid kontantmetoden: obetalda fakturor vid periodens slut är justerade</li>
                    <li>Föregående momsperiod är stängd — annars kan beräkningarna bli felaktiga</li>
                </ul>
            </div>
        </div>
    );
};

export default InstructionsStep;
